import { APP_INITIALIZER, ApplicationConfig } from '@angular/core';
import { Router, provideRouter, withRouterConfig } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideToastr } from 'ngx-toastr';

import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import {
  provideHttpClient,
  withFetch,
  withInterceptors,
} from '@angular/common/http';
import { AuthService } from './services/auth.service';
import {
  Observable,
  catchError,
  map,
  of,
  switchMap,
  tap,
  throwError,
} from 'rxjs';
import { TokenBearerInterceptor } from './interceptors/token-bearer.interceptor';
import { registerLocaleData } from '@angular/common';
import bg from '@angular/common/locales/bg';
registerLocaleData(bg);
export function initializeApplication(authSrv: AuthService, router: Router) {
  return (): Observable<boolean> => {
    // Make it run only on the CLIENT SIDE
    const isServer = typeof window === 'undefined';
    console.log('Server: ', isServer);
    if (isServer) {
      return of(true);
    }
    return authSrv.getMyAccount().pipe(
      catchError((response) => of(response)),
      tap((response) => {
        if (response.type === 'SUCCESS') {
          if (response.user) {
            if (
              response.user.role === 'administrator' ||
              response.user.role === 'owner'
            ) {
              if (!window.location.href.includes('admin-panel'))
                router.navigate(['/admin-panel'], {
                  replaceUrl: true,
                });
            }

            return;
          }
        }
        if (response.type === 'INVALID_TOKEN') {
          router.navigate(['/auth', 'login'], {
            replaceUrl: true,
          });
          return;
        }
      }),
      map(() => true)
    );
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApplication,
      multi: true,
      deps: [AuthService, Router],
    },
    provideRouter(routes),
    provideClientHydration(),
    provideAnimations(),
    provideHttpClient(withFetch(), withInterceptors([TokenBearerInterceptor])),
    provideToastr({ timeOut: 2000 }),
  ],
};
